import {Injectable} from '@angular/core';
import {AuthHttp} from '../../../user/services/auth/http/auth-http.service';
import {environment} from '../../../../../environments/environment';
import {ScheduleColumn} from '../../interfaces/ScheduleColumn';

@Injectable()
export class FlightScheduleColumnsService {
  private route = 'contract';
  public constructor(private http: AuthHttp) { }

  /**
   * get the flight columns
    * @param contractId
   * @returns {Promise<any>}
   */
  public getScheduleColumns(contractId): Promise<ScheduleColumn[]> {
    return this.http.get(`${environment.baseUrl}${this.route}/${contractId}/schedule-columns`).map((res) => res.json()).toPromise();
  }

  public storeScheduleColumn(scheduleColumn: ScheduleColumn) {
    return this.http.post(`${environment.baseUrl}${this.route}/${scheduleColumn.contract_id}/schedule-columns`, scheduleColumn)
      .map((res) => res.json()).toPromise();
  }
  public deleteScheduleColumn(scheduleColumn: ScheduleColumn) {
    return this.http.delete(`${environment.baseUrl}${this.route}/${scheduleColumn.contract_id}/schedule-columns/${scheduleColumn.id}`)
      .toPromise();
  }
}



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/contract/services/flight-schedule-columns/flight-schedule-columns.service.ts